import "../styles/navmenu.css";

import {
  BiHomeAlt,
  BiUser,
  BiBriefcase,
  BiMessageSquare,
} from "react-icons/bi";
import { FaGraduationCap } from "react-icons/fa";
import { useState, useEffect } from "react";

export default function Navmenu() {
  //hiding navigation bar on homepage
  const [navVisible, setnavVisible] = useState(false);
  const [current, setcurrent] = useState("home");
  function showNavmenu() {
    // When the scroll is greater than 50 viewport height, add the headerVisible class to the navbar tag
    if (this.scrollY >= 50) {
      setnavVisible(true);
    } else {
      setnavVisible(false);
    }
  }

  useEffect(() => {
    window.addEventListener("scroll", showNavmenu);
    window.addEventListener("scroll", activateLinks);
  });

  /* Navigating between page*/
  function goTo(elementId) {
    var element = document.getElementById(elementId);
    element.scrollIntoView({
      block: "start",
      behavior: "smooth",
    });
    return false;
  }
  // changing active link color and background
  function activateLinks() {
    const sections = document.querySelectorAll("section");
    sections.forEach((section) => {
      const sectionHeight = section.offsetHeight;
      const sectionTop = section.offsetTop - 58;
      if (
        window.pageYOffset > sectionTop &&
        window.pageYOffset <= sectionTop + sectionHeight
      ) {
        setcurrent(section.getAttribute("id"));
      }
    });
  }

  return (
    <div className={`nav__menu ${!navVisible && "hideNavMenu"}`}>
      <ul className="nav__list">
        <li className="nav__item">
          <button
            onClick={() => {
              goTo("home");
            }}
            className={`nav__link ${current === "home" && "active__link"}`}
          >
            <BiHomeAlt />
          </button>
        </li>

        <li className="nav__item">
          <button
            onClick={() => {
              goTo("about");
            }}
            className={`nav__link ${current === "about" && "active__link"}`}
          >
            <BiUser />
          </button>
        </li>

        <li className="nav__item">
          <button
            onClick={() => {
              goTo("education");
            }}
            className={`nav__link ${current === "education" && "active__link"}`}
          >
            <FaGraduationCap />
          </button>
        </li>

        <li className="nav__item">
          <button
            onClick={() => {
              goTo("projects");
            }}
            className={`nav__link ${current === "projects" && "active__link"}`}
          >
            <BiBriefcase />
          </button>
        </li>

        <li className="nav__item">
          <button
            onClick={() => {
              goTo("contact");
            }}
            className={`nav__link ${current === "contact" && "active__link"}`}
          >
            <BiMessageSquare />
          </button>
        </li>
      </ul>
    </div>
  );
}
